import React from "react";
import { RiPhoneFill } from "react-icons/ri";
import { AiFillMessage } from "react-icons/ai";
import { MdEmail } from "react-icons/md";
import { ImLocation2 } from "react-icons/im";

const MainIconBar = ({
  mobile,
  email,
  address,
  sColor,
  horizontal,
  backgroundColor = "white",
}) => {
  return (
    <div
      style={{ display: "flex", flexDirection: horizontal ? "row" : "column" }}
    >
      <a href={"tel:" + mobile}>
        <div
          className="main-icons-container"
          style={{
            backgroundColor: backgroundColor,
          }}
        >
          <RiPhoneFill className="icon-sizes" style={{ color: sColor }} />
        </div>
      </a>

      <a href={"sms:" + mobile}>
        <div
          className="main-icons-container"
          style={{
            backgroundColor: backgroundColor,
          }}
        >
          <AiFillMessage className="icon-sizes" style={{ color: sColor }} />
        </div>
      </a>
      {email && (
        <a href={"mailto:" + email}>
          <div
            className="main-icons-container"
            style={{
              backgroundColor: backgroundColor,
            }}
          >
            <MdEmail className="icon-sizes" style={{ color: sColor }} />
          </div>
        </a>
      )}

      {address && (
        <a
          href={"https://www.google.com/maps/search/" + address}
          target="_blank"
          rel="noreferrer"
        >
          <div
            className="main-icons-container"
            style={{
              backgroundColor: backgroundColor,
            }}
          >
            <ImLocation2 className="icon-sizes" style={{ color: sColor }} />
          </div>
        </a>
      )}
    </div>
  );
};

export default MainIconBar;
